module.exports = __webpack_public_path__ + "static/media/brand-plate-mockup.a1f7e292.jpg";